import services from 'services';
import {map} from 'ramda';
import {describeThrow} from 'utils/errors';
import {buildingSearchQueryBase, buildingInclude} from './constants';
import * as normalize from 'utils/normalize';
import {mapResponseData, getResponseData} from 'utils/app';
import msgs from 'dicts/messages';

let httpJson = null;
services.waitFor('api').then(x => (httpJson = x.httpJson));
let intl = null;
services.waitFor('intl').then(x => (intl = x));

export const getBuildings = query =>
	httpJson('get', '/buildings', {
		...buildingSearchQueryBase,
		include: buildingInclude,
		...query,
	})
		.catch(describeThrow(intl.formatMessage({id: msgs.contentFetchFailed})))
		.then(mapResponseData(map(normalize.building)));

export const getBuilding = id =>
	httpJson('get', `/buildings/${id}`, {
		include: buildingInclude,
		_d2dState: true,
	})
		.catch(describeThrow(intl.formatMessage({id: msgs.contentFetchFailed})))
		.then(getResponseData(normalize.building));

export const createVisit = visit =>
	httpJson('post', '/visits', {}, {body: visit}).catch(
		describeThrow(intl.formatMessage({id: 'Failed to save visit'})),
	);
